import {Box, Card, Skeleton, Typography} from "@mui/material";
import {useCustomNavigation} from "hooks/useCustomNavigation";
import {List} from "components/Admin/Pages/List/List";
import {seasonService} from "../../../services/seasonService";
import {Label} from "../../../components/Label/Label";
import dayjs from "dayjs";
import {collectionService} from "../../../services/collectionService";

export const CollectionList = () => {
  const {navigate} = useCustomNavigation();

  return (
    <List
      queryLimit={50}
      getList={collectionService.getList}
      loader={<Skeleton sx={{height: "50px"}} variant="rounded"/>}
    >
      {(item) => (
        <Card
          onClick={() => navigate(`./${item.id}`)}
          elevation={0}
        >
          <Box sx={{flexGrow: 1, padding: "20px"}}>
            <Label label="name"/>
            <Typography sx={styles.username}>
              {item.name}
            </Typography>
          </Box>
        </Card>
      )}
    </List>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "start",
    gap: "20px",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "background.paper",
    padding: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  username: {
    fontWeight: 500,
  },
  email: {
    color: "text.secondary",
  },
};
